import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';

import { useFormSelector } from '../../../../custom-hooks';
import { CREATE_NEW_COMPONENT_STEPS } from '../../../constants/editor.constants';
import { getEntityDefinition } from '../../../selectors/common.selectors';
import { getEntityDefinitionInfoNode } from '../../../utils/editor.utils';
import EntityModel from '../PropertyComponentModal/ExpressionModal/EntityModel';

const useStyles = makeStyles({
  root: {
    '& div[class*="MuiTextField"]': {
      maxWidth: 500,
      paddingBottom: 7,
      '@media (max-width: 1200px)': {
        width: 320,
      },
      '@media (max-width: 767px)': {
        width: 'auto',
      },
    },
    padding: '30px',
    '& div[class*="EntityModalComponent-root"]': {
      width: '375px',
      '& > h4': {
        display: 'none',
      },
      '& > div': {
        borderRadius: '3px',
      },
    },
    '& [class*="truncate"]': {
      userSelect: 'none',
    },
  },
});

const DataModelPicker = ({ dispatchStepChange, disableSelectEntity }) => {
  const classes = useStyles();
  const entityDefinition = useFormSelector(getEntityDefinition);

  const [value, setValue] = useState('');

  React.useEffect(() => {
    if (value) {
      const { nodeProperties, caption } = value;
      const nodeInformation = getEntityDefinitionInfoNode(entityDefinition, nodeProperties);

      if (nodeInformation && (!nodeInformation.isEntity || !disableSelectEntity)) {
        dispatchStepChange({
          type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_4, dataModel: caption, ...nodeInformation },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onUpdateValue = React.useCallback(
    (value) => {
      const { nodeProperties } = value;
      const nodeInformation = getEntityDefinitionInfoNode(entityDefinition, nodeProperties);
      const changedValue =
        value?.nodeProperties?.label === 'Fields' ||
        (nodeInformation?.isEntity && disableSelectEntity)
          ? ''
          : value;
      setValue(changedValue);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value]
  );

  return (
    <div className={classes.root}>
      <EntityModel
        action={true}
        allowEntity={true}
        change={onUpdateValue}
        showSearch
        height={350}
        width={500}
      />
    </div>
  );
};

export default DataModelPicker;
